var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferuploadingimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H30.8572C37.4846 0 42.8571 5.37258 42.8571 12V28C42.8571 34.6274 37.4846 40 30.8571 40H12C5.37257 40 0 34.6274 0 28V12Z",
    fill: "#D8EAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_31398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3346 23.3333L21.0013 20L17.668 23.3333",
    stroke: "#004276",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 20V27.5",
    stroke: "#004276",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9909 25.3249C28.8037 24.8818 29.4458 24.1806 29.8158 23.3321C30.1858 22.4835 30.2627 21.5359 30.0344 20.6388C29.8061 19.7417 29.2855 18.9462 28.5548 18.3778C27.8241 17.8094 26.925 17.5005 25.9992 17.4999H24.9492C24.697 16.5243 24.2269 15.6185 23.5742 14.8507C22.9215 14.0829 22.1033 13.4731 21.181 13.0671C20.2587 12.661 19.2564 12.4694 18.2493 12.5065C17.2423 12.5436 16.2568 12.8085 15.3669 13.2813C14.477 13.7541 13.7058 14.4225 13.1114 15.2362C12.517 16.05 12.1148 16.9879 11.9351 17.9794C11.7553 18.9709 11.8027 19.9903 12.0736 20.961C12.3445 21.9316 12.8319 22.8281 13.4992 23.5832",
    stroke: "#004276",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_31398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferuploadingimage);
export default __webpack_public_path__ + "static/media/prefer uploading image.fa3fbd2a92b2a5fa52460cb546615e1c.svg";
export { ForwardRef as ReactComponent };